import { render, staticRenderFns } from "./NewZgbTeamMembersEdit.vue?vue&type=template&id=b2a12bfc"
import script from "./NewZgbTeamMembersEdit.vue?vue&type=script&lang=js"
export * from "./NewZgbTeamMembersEdit.vue?vue&type=script&lang=js"
import style0 from "./NewZgbTeamMembersEdit.vue?vue&type=style&index=0&id=b2a12bfc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports